<template>
    <div class="w-full flex flex-col text-ternary py-4">


        <div class="flex flex-col mt-4" v-if="$apollo.queries.getJobOpportunities.loading">
            <table-shimmer
                :titleHeaders="['#', 'Company Name', 'Job Title', 'Position', 'Vacancy', 'Job Offer Start Date', 'Job Offer Close Date', 'Actions']"
                :rows="first"></table-shimmer>
        </div>
        <div v-else-if="!$apollo.queries.getJobOpportunities.loading && !hasItems"
            class="h-full flex justify-center items-center">
            <h1 class="text-center text-xl font-medium">No jobs found!</h1>
        </div>
        <div v-else class="flex flex-col mt-4">
            <div class="flex flex-col overflow-x-auto">
                <div class="inline-block min-w-full py-2">
                    <div class="overflow-x-auto">
                        <table class="min-w-full text-left text-sm font-light">
                            <thead class="border-b font-medium dark:border-neutral-500">
                                <tr>
                                    <th scope="col" class="px-6 py-2 text-gray-400 w-8">#</th>
                                    <th scope="col" class="px-6 py-2 text-gray-400">Company Name</th>
                                    <th scope="col" class="px-6 py-2 text-gray-400">Job Title</th>
                                    <th scope="col" class="px-6 py-2 text-gray-400">Position</th>
                                    <th scope="col" class="px-6 py-2 text-gray-400">Vacancy</th>
                                    <th scope="col" class="px-6 py-2 text-gray-400">Job Offer Start Date</th>
                                    <th scope="col" class="px-6 py-2 text-gray-400">Job Offer Close Date</th>
                                    <th scope="col" class="px-6 py-2 text-gray-400">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in items" :key="index"
                                    class="border-b border-dashed dark:border-neutral-500">
                                    <td class="whitespace-nowrap px-6 py-2 font-medium">{{ paginatorInfo.firstItem +
                                        index }}</td>
                                    <td class="whitespace-nowrap px-6 py-2">{{ item.partner ?
                                        item.partner.en_company_name : item.employer_name }}</td>
                                    <td class="whitespace-nowrap px-6 py-2">{{ item.job_title }}</td>
                                    <td class="whitespace-nowrap px-6 py-2">{{ item.position_name }}</td>
                                    <td class="whitespace-nowrap px-6 py-2">{{ item.vacancy }}</td>
                                    <td class="whitespace-nowrap px-6 py-2">{{ formattedDate(item.job_start_date) }}
                                    </td>
                                    <td class="whitespace-nowrap px-6 py-2">{{ formattedDate(item.job_close_date) }}
                                    </td>
                                    <td class="px-6 py-2">
                                        <div class="flex">
                                            <div v-if="hasPermission('jobs-show')" @click.stop="gotToJob(item.token)"
                                                class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                                                <icon-eye
                                                    class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-eye>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="mt-4">
                <pagination :paginatorInfo="paginatorInfo" :setPage="setPage"></pagination>
            </div>
        </div>
    </div>
</template>

<script>
import gql from 'graphql-tag';
import Pagination from "../../../../components/shared/pagination.vue";
import TableShimmer from '../../../../components/shared/TableShimmer.vue';
import IconEye from "../../../../components/icons/IconEye.vue";
export default {
    name: 'tab- 2',
    components: {
        TableShimmer,
        IconEye,
        Pagination,
    },
    data() {
        return {
            getJobOpportunities: [],
            first: 10,
            page: 1,
        }
    },
    watch: {
        getJobOpportunities(newVal) {
            if (newVal.error) {
                if (newVal.error_code == 403) {
                    this.$router.replace('/no-permission');
                } else if (newVal.error_code == 401) {
                    this.$router.replace('/');
                } else {
                    alert(newVal.message);
                    this.$router.replace('/');
                }
            }
        },
    },
    computed: {
        items() {
            return this.getJobOpportunities.data;
        },
        hasItems() {
            if (this.items && this.items.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        paginatorInfo() {
            return this.getJobOpportunities.paginatorInfo;
        },
        role() {
            return this.$store.getters.role;
        },
        studentId() {
            return this.$store.getters.student_id;
        },
    },
    apollo: {
        getJobOpportunities() {
            return {
                query: gql`query GetJobOpportunities($first: Int!, $page: Int!, $student_id: String) {
                    getJobOpportunities(first: $first, page: $page, student_id: $student_id) {
                        error
                        error_code
                        message
                        data {
                            id
                            token
                            grade_number
                            job_title
                            position_name
                            position_number
                            job_description
                            minimum_qualification
                            preferred_qualification
                            expected_skills
                            special_instructions
                            division
                            department
                            job_start_date
                            job_close_date
                            job_category
                            salary
                            vacancy
                            approved_count
                            rejected_count
                            days_ago
                            benefits
                            job_location
                            working_hours
                            contract_type
                            partner {
                                en_company_name
                            }
                            employer_name
                        }
                        paginatorInfo {
                            count
                            currentPage
                            firstItem
                            hasMorePages
                            lastItem
                            lastPage
                            perPage
                            total
                        }
                    }
                }`,
                variables() {
                    return {
                        first: this.first,
                        page: this.page,
                        student_id: this.studentId,
                    }
                },
                fetchPolicy: 'cache-and-network'
            }
        },
    },
    methods: {
        formattedDate(date) {
            if (date) {
                const parsedDate = new Date(date);
                return parsedDate.toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                }).replace(/\//g, '-');
            } else {
                return "";
            }
        },
        setPage(page) {
            this.page = page;
        },
        dateInAgo(daysAgo) {
            const today = new Date();
            const targetDate = new Date();
            targetDate.setDate(today.getDate() - daysAgo);

            const diffTime = Math.abs(today - targetDate);
            const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

            if (diffDays === 0) {
                return 'Today';
            } else if (diffDays === 1) {
                return 'Yesterday';
            } else if (diffDays <= 7) {
                return `${diffDays} days ago`;
            } else if (diffDays <= 30) {
                const diffWeeks = Math.floor(diffDays / 7);
                return `${diffWeeks} week${diffWeeks > 1 ? 's' : ''} ago`;
            } else if (diffDays <= 365) {
                const diffMonths = Math.floor(diffDays / 30);
                return `${diffMonths} month${diffMonths > 1 ? 's' : ''} ago`;
            } else {
                const diffYears = Math.floor(diffDays / 365);
                return `${diffYears} year${diffYears > 1 ? 's' : ''} ago`;
            }
        },
        hasPermission(crudName) {
            if (this.role == 'superadmin') {
                return true;
            } else {
                const permissions = this.$store.getters.permissions;
                const permissionsArray = permissions.split(",");
                if (permissionsArray.includes(crudName)) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        gotToJob(token) {
            const url = '/employment/job-opportunity/' + token;
            this.$router.replace(url);
        },
    },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>